<div class="product">
  <div class="preview" [ngClass]="{'hidden': !previewViewVisible$.getValue()}">
    <img src="./../../../assets/images/decathlon-preview.png">
  </div>

  <div class="visualisation" [ngClass]="{'hidden': previewViewVisible$.getValue()}">
    <mat-progress-bar class="twikit-loading-bar" mode="query" *ngIf="!(loaded$ | async)"></mat-progress-bar>
    <img class="canvas-rotate-icon" src="../../../assets/images/rotate.svg"/>
    <!--<app-camera-controls [views]="cameraStands$.getValue()" (changeCamera)="updateCameraViewByView($event)"></app-camera-controls>-->
    <div #visualisation class="visualisation-container">

    </div>
  </div>
  <div class="sidebar" id="sidebar"
       [ngClass]="{'hidden-content': !sidebarVisible$.getValue(), 'hidden': previewViewVisible$.getValue()}">
    <div class="sidebar-toggle" [ngClass]="{'closed': !sidebarVisible$.getValue()}" (click)="toggleSidebar()">
      <div class="arrow"></div>
    </div>
    <div class="sidebar-content" [ngClass]="{'hidden': !sidebarVisible$.getValue()}">
      <mat-tab-group [selectedIndex]="selectedTabIndex" (selectedIndexChange)="tabGroupChanged($event)"
                     [ngClass]="{'hidden': !(loaded$ | async)}">
        <mat-tab [label]="parameterTabs$.getValue().group0?.name || '1'">
          <ng-template class="parameters" #parametercards0></ng-template>
        </mat-tab>
        <mat-tab [label]="parameterTabs$.getValue().group1?.name || '2'">
          <ng-template class="parameters" #parametercards1></ng-template>
        </mat-tab>
        <mat-tab [label]="parameterTabs$.getValue().group2?.name || '3'">
          <ng-template class="parameters" #parametercards2></ng-template>
        </mat-tab>
      </mat-tab-group>
      <div class="twikit-tab-navigation">
        <span class="" [ngClass]="{'active': selectedTabIndex > 0}" (click)="previousStep()">< Précédent</span>
        <span class="" [ngClass]="{'active': selectedTabIndex !== (numberOfTabs - 1)}"
              (click)="nextStep()">Suivant ></span>
      </div>
    </div>
  </div>
  <div class="order-button-container">

    <!--<span class="order-button-description">Click here to get your<br/>free handlebars</span>
    <span class="order-button-description">Commandez bientôt vos poignées ici &nbsp;&nbsp;
    </span>
    <img class="order-arrow" src="./../../../assets/images/arrow.svg">-->
    <button class="tw-dcn-button order-button" (click)="order()"
            [disabled]="((saving$ | async) || !(loaded$ | async))">
      <span>J'Y VAIS</span>
    </button>
  </div>
  <mat-slide-toggle
    class="preview-toggle" (change)="previewViewVisible$.next($event.checked)" *ngIf="false">
    {{previewViewVisible$.getValue() ? 'Hide preview' : 'Show preview'}}
  </mat-slide-toggle>
</div>
